import React, { useContext } from 'react';

import AppContext from '../context';

const GenderSelector = () => {
  const context = useContext(AppContext);

  const genders = [
    {
      name: 'Girl',
      icon: '/assets/icon_girl.svg'
    },
    {
      name: 'Boy',
      icon: '/assets/icon_boy.svg'
    }
  ];

  const selectGender = type => {
    const updatedFilters = { ...context.filters };
    updatedFilters.gender = type.name;

    context.setFilters(updatedFilters);

    context.setStep(4);
    if (context.progress <= context.step) {
      context.setProgress(4);
    }
  }

  return (
    <div className="program-filter">
      {context.displayText ?
        <p>
          {context.displayText.gender_text ?
            <span>{ context.displayText.gender_text }</span>
          :
            <span>My camper is a:</span>
          }
        </p>
      : null}

      {genders.map(type =>
        <button
          key={type.name}
          className={`program-option program-option--gender ${context.filters.gender === type.name ? 'selected' : ''}`}
          type="button"
          onClick={selectGender.bind(this, type)}
        >
          <img src={type.icon}/>
          <span>{ type.name }</span>
        </button>
      )}
    </div>
  );
}

export default GenderSelector;